export default __webpack_public_path__ + "static/media/the-stevenson-hotel.98133245.png";